module.exports = __webpack_public_path__ + "static/power-9438eafc6ec76eee405b33b2a99c3e04.svg";